//创建a链接跳转
export const createA = (url, target) => {
  const elink = document.createElement('a')
  elink.style.display = 'none'
  elink.href = url
  elink.target = '_blank'
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}
export const downFile = (res, name) => {
  let type = res.headers['content-type']
  let disposition=decodeURI(res.headers['content-disposition'].split('=')[1]||"")
  let data = res.data
  let blob = new Blob([data], {type: type})
  let url = URL.createObjectURL(blob)
  const elink = document.createElement('a')
  elink.style.display = 'none'
  elink.href = url
  elink.target = '_blank'
  elink.download = disposition
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}
export const getCookie = (name) => {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}

export const delCookie = (name, domain) => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null && !domain) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  } else {
    document.cookie = name + "=" + cval + ";domain=" + domain + ";expires=" + exp.toGMTString();
  }
}
export const SetCookie = (name, value, domain) => {
  var str = name + "=" + escape(value) + ";domain=" + domain + ";path=/";
  var date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000); //设置date为当前时间加一年
  str += ";expires=" + date.toGMTString();
  document.cookie = str;
}
export const delAllCookie = () => {
  delCookie('louguanjia_app_id', 'localhost')
  delCookie('louguanjia_app_ticket', 'localhost')
  delCookie('louguanjia_app_id', 'www.shouxi.pre')
  delCookie('louguanjia_app_ticket', 'www.shouxi.pre')
  delCookie('louguanjia_app_id', '.360aidata.com')
  delCookie('louguanjia_app_ticket', '.360aidata.com')
}

// 数据字典对象转 option(value,label)
export const toOption = (obj) => {
  let optionArr = [];
  for (var key in obj) {
    optionArr.push({value: key, label: obj[key]});
  }
  return optionArr;
}

//获取当前月份
const getCurMonth = () => {
  let year = new Date().getFullYear(),
    month = new Date().getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  return `${year}-${month}`
}
//获取当月开始到当天arr
const getCurMounthFirstAndEnd = () => {
  let year = new Date().getFullYear(),
    day = new Date().getDate(),
    month = new Date().getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return [`${year}-${month}-01`, `${year}-${month}-${day}`]

}

//根据月份获取[第一天,最后一天]
export const monthFirstAndEndArray = (date => {
  let year = '',
    month = '',
    day = '',
    arr = []
  if (date==getCurMonth()) {
    return getCurMounthFirstAndEnd()
  }
  year = date.split('-')[0]
  month = date.split('-')[1]
  switch (month) {
    case '01':
      arr = [`${date}-01`, `${date}-31`];
      break;
    case '02':
      if (year % 4 == 0) {
        arr = [`${date}-01`, `${date}-29`];
        break;
      } else {
        arr = [`${date}-01`, `${date}-28`];
        break;
      }
    case '03':
      arr = [`${date}-01`, `${date}-31`];
      break;
    case '04':
      arr = [`${date}-01`, `${date}-30`];
      break;
    case '05':
      arr = [`${date}-01`, `${date}-31`];
      break;

    case '06':
      arr = [`${date}-01`, `${date}-30`];
      break;
    case '07':
      arr = [`${date}-01`, `${date}-31`];
      break;
    case '08':
      arr = [`${date}-01`, `${date}-31`];
      break;
    case '09':
      arr = [`${date}-01`, `${date}-30`];
      break;
    case '10':
      arr = [`${date}-01`, `${date}-31`];
      break;
    case '11':
      arr = [`${date}-01`, `${date}-30`];
      break;
    case '12':
      arr = [`${date}-01`, `${date}-31`];
      break;
  }
  return arr

})

//格式化金额
export const outputdollars = (num)=>{
  if(typeof num !=='number'){return;}
  var numArr=num.toFixed(2).toString().split('.');
  var temArr=[];
  var lastArr=[];
  for (var i=numArr[0].length;i>0;i-=3) {
      temArr.unshift(numArr[0].substring(i-3,i));
  }
  lastArr.push(temArr.join(','));
  lastArr.push(numArr[1]);
  
  return lastArr.join('.');
}